/**
 * @generated SignedSource<<3ead02f9791e6c5120cbb623b0eb68e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExperimentsFlagAssignmentInput = {
  input: ExperimentsFlagAssignmentInput;
};
export type ExperimentsFlagAssignmentInput = {
  flagName: string;
  variantName: string;
};
export type ExperimentsRecordExperimentsAssignmentMutation$variables = {
  input: AddExperimentsFlagAssignmentInput;
};
export type ExperimentsRecordExperimentsAssignmentMutation$data = {
  readonly addExperimentsFlagAssignment: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly experimentsFlagHistoryNode: {
      readonly createdOn: any;
      readonly flagName: string | null | undefined;
      readonly id: string;
      readonly user: {
        readonly id: string;
      } | null | undefined;
      readonly variantName: string | null | undefined;
    } | null | undefined;
  };
};
export type ExperimentsRecordExperimentsAssignmentMutation = {
  response: ExperimentsRecordExperimentsAssignmentMutation$data;
  variables: ExperimentsRecordExperimentsAssignmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddExperimentsFlagAssignmentPayload",
    "kind": "LinkedField",
    "name": "addExperimentsFlagAssignment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExperimentsFlagHistoryNode",
        "kind": "LinkedField",
        "name": "experimentsFlagHistoryNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flagName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "variantName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperimentsRecordExperimentsAssignmentMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperimentsRecordExperimentsAssignmentMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f1e917eb508b7a38f8e290eb1628a250",
    "id": null,
    "metadata": {},
    "name": "ExperimentsRecordExperimentsAssignmentMutation",
    "operationKind": "mutation",
    "text": "mutation ExperimentsRecordExperimentsAssignmentMutation(\n  $input: AddExperimentsFlagAssignmentInput!\n) {\n  addExperimentsFlagAssignment(input: $input) {\n    experimentsFlagHistoryNode {\n      id\n      user {\n        id\n      }\n      flagName\n      variantName\n      createdOn\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11b5e336464b0b6b0e6c74ab23f6d253";

export default node;
